import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TimelineCard from '../TimelineCard';
import styles from './ReferralTimeline.module.scss';
const ReferralTimeline = () => {
    const { t } = useTranslation('translation', {
        keyPrefix: 'REFERRAL_TIMELINE'
    });
    const { milestones, loading: isLoading } = useSelector((state) => state.timeline);
    const completedMilestones = useMemo(() => {
        if (!milestones || milestones.length === 0)
            return [];
        const completed = milestones.filter((m) => m.completed).sort((a, b) => b.displayOrder - a.displayOrder);
        // If none completed → show displayOrder 1 milestone only
        if (completed.length === 0) {
            const firstMilestone = milestones.find((m) => m.displayOrder === 1);
            return firstMilestone ? [firstMilestone] : [];
        }
        return completed;
    }, [milestones]);
    if (isLoading) {
        return (_jsx(Box, { className: styles.wrapper, sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }, children: _jsx(CircularProgress, { size: 40 }) }));
    }
    return (_jsxs(Box, { className: styles.wrapper, children: [_jsx(Box, { className: styles.header, children: _jsx(Typography, { variant: "h3", children: t('TITLE') }) }), _jsx(Box, { className: styles.content, children: _jsx(Box, { className: styles.timeline_container, children: completedMilestones.map((milestone, index) => {
                        var _a;
                        return (_jsx(TimelineCard, { milestone: milestone, isFirst: index === 0, isLast: index === completedMilestones.length - 1 }, (_a = milestone.id) !== null && _a !== void 0 ? _a : milestone.milestoneCode));
                    }) }) })] }));
};
export default ReferralTimeline;
